import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookie } from "../hooks/auth/useCookie";
import { CookieKeys } from "../hooks/auth/AuthProvider";

export function Auth() {
    const { setCookie } = useCookie();

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const accessToken = searchParams.get("accessToken");
        const refreshToken = searchParams.get("refreshToken");

        if (accessToken && refreshToken) {
            // 쿠키에 토큰 저장
            setCookie(CookieKeys.ACCESS_TOKEN, accessToken);
            setCookie(CookieKeys.REFRESH_TOKEN, refreshToken);
            console.log("토큰이 쿠키에 저장되었습니다.");

            // 메인 페이지로 리다이렉트
            window.location.href = "/";
        } else {
            console.error("URL에서 토큰을 찾을 수 없습니다.");
            navigate("/login");
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            인증 처리 중...
        </div>
    );
}